import script from "./ShapeItemThumbnail.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShapeItemThumbnail.vue?vue&type=script&lang=ts&setup=true"

import "./ShapeItemThumbnail.vue?vue&type=style&index=0&id=70c998b7&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70c998b7"]])

export default __exports__